export const SetLocalkeycloakToken = (keycloakToken) => localStorage.setItem('keycloakToken', keycloakToken)

export const GetLocalkeycloakToken = () => localStorage.getItem('keycloakToken')

export const DeleteLocalkeycloakToken = () => localStorage.removeItem('keycloakToken')
